export default __webpack_public_path__ + "static/media/logo-icon-blue.e98dadc6.svg";